export default __webpack_public_path__ + "static/media/Bitmap_12.60c2d8e9.jpg";